import { Component, ViewChild } from '@angular/core';
import { AlertService, AuthService } from '@app/core/services';
import { BaseContextmenuComponent } from './base-contextmenu.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { LiberacionReportComponent } from '@app/core/reports'


@Component({
  selector: 'vehicle-contextmenu',
  template: `

    <liberacion-report></liberacion-report>

    <kendo-contextmenu (select)="onSelect($event)">
      <kendo-menu-item url="detalle">
        <ng-template kendoMenuItemTemplate let-item="item">
          <div class="menu-header">
            <span class="k-icon k-i-information"></span>
            Folio de expediente: {{contextItem.sku_exp}}
          </div>
        </ng-template>
      </kendo-menu-item>
      <kendo-menu-item url="editar" text="Editar" icon="edit" *ngIf="this.authService.hasPermission(['ENTRADAS_VEHICULOS:EDITAR']) && contextItem?.id_vehicle_status == 1"></kendo-menu-item>
      <kendo-menu-item url="eliminar" text="Eliminar" icon="trash" *ngIf="this.authService.hasPermission(['ENTRADAS_VEHICULOS:ELIMINAR']) && contextItem?.id_vehicle_status == 1"></kendo-menu-item>
      <kendo-menu-item url="ver_fotos" text="Ver fotografías" icon="photo-camera"></kendo-menu-item>
      <kendo-menu-item url="ver_liberacion" text="Ver liberación" icon="pdf" *ngIf="this.authService.hasPermission(['LIBERACIONES_VEHICULOS:IMPRIMIR']) && contextItem?.id_vehicle_status == 3"></kendo-menu-item>
      <kendo-menu-item url="factura" text="Actualizar factura" icon="file" *ngIf="this.authService.hasPermission(['ENTRADAS_VEHICULOS:EDITAR']) && (contextItem?.id_vehicle_status == 3 || contextItem?.id_vehicle_status == 4)"></kendo-menu-item>
      <kendo-menu-item [separator]="true" *ngIf="(this.authService.hasPermission(['VEHICULOS_COSTOS_GRUAS:EDITAR']) && contextItem?.id_vehicle_status == 1) || (this.authService.hasPermission(['VEHICULOS_COSTOS_GRUAS:ELIMINAR']) && contextItem?.id_vehicle_status == 2)"></kendo-menu-item>      
      <kendo-menu-item url="editar_costo_grua" text="Definir costo de grúa" icon="check" *ngIf="this.authService.hasPermission(['VEHICULOS_COSTOS_GRUAS:EDITAR']) && contextItem?.id_vehicle_status == 1"></kendo-menu-item>
      <kendo-menu-item url="eliminar_costo_grua" text="Quitar costo de grúa ({{intl.formatNumber(contextItem?.cost_crane, 'c2')}})" icon="close" *ngIf="this.authService.hasPermission(['VEHICULOS_COSTOS_GRUAS:ELIMINAR']) && contextItem?.id_vehicle_status == 2"></kendo-menu-item>
      <kendo-menu-item [separator]="true" *ngIf="(this.authService.hasPermission(['LIBERACIONES_VEHICULOS:EDITAR']) && contextItem?.id_vehicle_status == 2) || (this.authService.hasPermission(['LIBERACIONES_VEHICULOS:ELIMINAR']) && contextItem?.id_vehicle_status == 3)"></kendo-menu-item>
      <kendo-menu-item url="liberar" text="Liberar" icon="arrow-right" *ngIf="this.authService.hasPermission(['LIBERACIONES_VEHICULOS:EDITAR']) && contextItem?.id_vehicle_status == 2"></kendo-menu-item>
      <kendo-menu-item url="eliminar_liberacion" text="Cancelar liberación" icon="cancel" *ngIf="this.authService.hasPermission(['LIBERACIONES_VEHICULOS:ELIMINAR']) && contextItem?.id_vehicle_status == 3"></kendo-menu-item>
    </kendo-contextmenu>`,
  styles: [`
    .menu-header {
      color: #ff6358
    }
  `]
})
export class VehicleContextmenuComponent extends BaseContextmenuComponent {  

  //Report - Liberacion
  @ViewChild(LiberacionReportComponent, {static: false}) report_liberacion !: LiberacionReportComponent;

  //Overrides
  constructor(protected authService: AuthService, protected alertService: AlertService, protected intl: IntlService) {
            
    super(authService, alertService);
    // console.log(this.constructor.name);   
    
  }

  //Overrides
  protected onSelect(event): void {

    // console.log(this.constructor.name + ":onSelect", event.item, this.contextItem);
    
    event.preventDefault();
    let url: string = event.item.url;

    if (url === 'editar') {

      // Editar

    } else if (url === 'eliminar') {
        
      // Eliminar

    } else if (url === 'ver_fotos') {
        
      // Ver - Fotografías

    } else if (url === 'ver_liberacion') {
        
      // Ver - Liberación
      console.log(event.item);
      this.report_liberacion.name = `Liberación Exp ${this.contextItem.sku_exp}`;
      this.report_liberacion.download(this.contextItem.id, this.contextItem);

    } else if (url === 'editar_costo_grua') {
        
      // Editar - Costo de grúa

    } else if (url === 'eliminar_costo_grua') {
        
      // Eliminar - Costo de grúa

    } else if (url === 'liberar') {
        
      // Liberar

    } else if (url === 'eliminar_liberacion') {
        
      // Eliminar Liberación

    } else if (url === 'factura') {
        
      // Actualizar Factura

    }


    //Emitir evento: selected
    this.select.emit({menu: event.item, contextItem: this.contextItem});

  }

}
